/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/404'
import ConfirmMail from '@/components/ConfirmMail'
import ConfirmDelete from '@/components/ConfirmDelete'
import ConfirmSignup from '@/components/ConfirmSignup.vue'

import Login from "@/pages/auth/Login"
import ResetPassword from "@/pages/auth/ResetPassword"
import ResetPasswordForm from "@/pages/auth/ResetPasswordForm"
import NewPassword from "@/pages/auth/NewPassword"
import ResetPasswordVerification from "@/pages/auth/ResetPasswordVerification"
import Home from "@/pages/pages/Home"
import Logs from "@/pages/pages/Logs"
import Earnings from "@/pages/pages/Earnings"
import Notification from "@/pages/pages/Notification"
import Customers from "@/pages/pages/customers/Customers"
import ExamsTab from "@/pages/pages/exams/ExamsTab"
import EditPackages from "@/pages/pages/exams/EditPackages"
import EditTest from "@/pages/pages/exams/EditTest"
import EditQuestions from "@/pages/pages/exams/EditQuestions"
import Customer from "@/pages/pages/customers/Customer"
import Profile from "@/pages/pages/profile/Profile"
import AddNewCustomer from "@/pages/pages/customers/AddNewCustomer"
import EditCustomer from "@/pages/pages/customers/EditCustomer"
import LogView from '@/pages/pages/LogView.vue'
import WithdrawClick from '@/pages/pages/WithdrawClick.vue'
import PoliceMans from '@/pages/pages/PoliceMans.vue'
import EditPoliceman from '@/pages/pages/EditPoliceman'
import Packages from '../pages/pages/package/Packages'
import CreatePackage from '../pages/pages/package/CreatePackage'
import EditPackage from '../pages/pages/package/EditPackage'
import Manual from '../pages/pages/exams/Manual'
import ViewPackage from '../pages/pages/package/ViewPackage.vue'
import StudentViewPack from '../pages/pages/package/StudentViewPack.vue'
import Classes from '../pages/pages/classes/Classes'
import CreateClass from '../pages/pages/classes/CreateClass'
import EditClass from '../pages/pages/classes/EditClass'
import SelectTime from '../pages/pages/classes/SelectTime.vue'
import Viewclass from '../pages/pages/classes/Viewclass'
import auth from '@/utils/auth'

function requireAuth(to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
}
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: "/",
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/404',
      component: ErrorPage,
      name: 'ErrorPage'
    },
    {
      path: '/confirmation/:id',
      component: ConfirmMail,
      name: 'confirmation',
      props: true
    },
    {
      path: '/verification/:id',
      component: ConfirmMail,
      name: 'verification',
      props: true
    },
    {
      path: "/logs",
      component: Logs,
      beforeEnter: requireAuth
    },
    {
      path: "/resetpassword",
      component: ResetPassword,
    },
    {
      path: "/resetpassword/:token",
      component: ResetPasswordForm,
      props:true
    },
    {
      path: "/notification",
      component: Notification,
      beforeEnter: requireAuth
    },
    {
      path: "/customers",
      component: Customers,
      beforeEnter: requireAuth
      // children: []
    },
    {
      path: "/profile",
      component: Profile,
      beforeEnter: requireAuth
    },
    {
      path: "/earnings",
      component: Earnings,
      beforeEnter: requireAuth
    },

    {
      path: "/policemans",
      component: PoliceMans,
      beforeEnter: requireAuth
    },

    {
      path: "/editpolice/:id",
      component: EditPoliceman,
      beforeEnter: requireAuth
    },
    {
      path: "/deletepolice/:id",
      component: ConfirmDelete,
      beforeEnter: requireAuth
    },


    {
      path: 'ConfirmSignup',
      component: ConfirmSignup,
      beforeEnter: requireAuth
    },
    {
      path: 'ConfirmDelete',
      component: ConfirmDelete,
      beforeEnter: requireAuth
    },
    {
      path: "/addnewcustomers",
      component: AddNewCustomer,
      beforeEnter: requireAuth
    },
    {
      path: "/customer/:id",
      component: Customer,
      beforeEnter: requireAuth,
      props: true

    },
    {
      path: "/editcustomer/:id",
      component: EditCustomer,
      beforeEnter: requireAuth,
      props: true

    },
    {
      path: "/logview/:id",
      component: LogView,
      beforeEnter: requireAuth,
      props: true

    },
    {
      path: "withdraw/:id",
      component: WithdrawClick,
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: '/classes',
      name: 'Classes',
      component: Classes
    },
    {
      path: '/Packages',
      name: 'Packages',
      component: Packages
    },
    {
      path: '/viewclass',
      name: 'Viewclass',
      component: Viewclass
    },
    {
      path: '/SelectTime',
      component: SelectTime
    },
    {
      path: '/examstab',
      component: ExamsTab
    },
    {
      props:true,
      path: '/editpackages/:id',
      component: EditPackages
    },
    {
      props:true,
      path: '/editquestions/:id',
      component: EditQuestions
    },
    {
      props:true,
      path: '/edittest/:id',
      component: EditTest
    },
    {
      props:true,
      path: '/viewpackage/:id',
      component: ViewPackage
    },
    {
      path: '/StudentViewPack',
      component: StudentViewPack
    },
    {
      path: '/createpackage',
      component: CreatePackage
    },
    {
      props:true,
      path: '/EditPackage/:id',
      component: EditPackage
    },
    {
      path: '/Manual',
      component: Manual
    },
    {
      path: '/CreateClass',
      component: CreateClass
    },
    {
      props:true,
      path: '/EditClass/:id',
      component: EditClass
    },
    {
      path: '/login',
      component: Login,
      name: 'Login',
      beforeEnter: (to, from, next) => {
        var Token = Store.state.token;
        console.log(Token);
        if (Token) {
          console.log('hiiiii');
          next('/')
        } else {
          next();
        }
      },
    },

    {
      path: '*',
      redirect: '/404',
      beforeEnter: (to, from, next) => {
        var Token = Store.state.token;
        console.log(Token);
        if (Token) {
          auth.logout()
          next('/login')
        } else {
          next();
        }
      },

    },
    {
      path: '/logout',
      beforeEnter(to, from, next) {
        auth.logout()
        next('/login')
      }
    },
  ],


})



// WEBPACK FOOTER //
// ./src/router/index.js